<template>
  <div class="is-clearfix">
    <a class="is-pulled-right lxm-login-other-button__register" @click="registerClicked">注册</a>

    <template v-if="!needPhone">
      <a class="is-pulled-right lxm-login-other-button__way" @click="emailClicked">邮箱登录</a>
    </template>

    <template v-if="needPhone">
      <a class="is-pulled-right lxm-login-other-button__way" @click="phoneClicked">手机登录</a>
    </template>
  </div>
</template>

<style lang="stylus" scoped>
  @import '../../styles/index.styl'
  .lxm-login-other-button__register, .lxm-login-other-button__way
    color: login-blue
    font-size: siz(11)
    margin-top: siz(10)
    font-weight: 500
  .lxm-login-other-button__register
    margin-left: siz(13)
</style>

<script>
  import * as mTypes from '../../../store/mutation-types'
  export default {
    props: {
      needPhone: {
        type: Boolean,
        default: true
      }
    },
    methods: {
      emailClicked () {
        this.$store.commit(mTypes.TRANSITION_SET_BACK)
        this.$router.push('/auth/login-email')
      },
      phoneClicked () {
        this.$store.commit(mTypes.TRANSITION_SET_BACK)
        this.$router.push('/auth/login')
      },
      registerClicked () {
        this.$store.commit(mTypes.TRANSITION_SET_BACK)
        this.$router.push('/auth/register')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// OtherButton.vue?365adec3